module.exports = __webpack_public_path__ + "static/media/dental-bg-login.68e8e1d5.jpg";